/*
 * action types
 */

export const GET_BANNER_REQUEST = "GET_BANNER_REQUEST";
export const GET_BANNER_SUCCESS = "GET_BANNER_SUCCESS";
export const GET_BANNER_FAILURE = "GET_BANNER_FAILURE";
export const DISMISS_BANNER_REQUEST = "DISMISS_BANNER_REQUEST";
export const DISMISS_BANNER_SUCCESS = "DISMISS_BANNER_SUCCESS";

/*
 * action creators
 */
export const getBannerRequest = () => ({
    type: GET_BANNER_REQUEST
});

export const getBannerSuccess = items => ({
    type: GET_BANNER_SUCCESS,
    items
});

export const getBannerFailure = () => ({
    type: GET_BANNER_FAILURE
});

export const dismissBannerRequest = () => ({
    type: DISMISS_BANNER_REQUEST
});

export const dismissBannerSuccess = () => ({
    type: DISMISS_BANNER_SUCCESS
});



// WEBPACK FOOTER //
// ./src/actions/banner.js